module.exports = __webpack_public_path__ + "static/media/MonkeyLogo.dad28cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/MonkeyLogo.png
// module id = 189
// module chunks = 0